import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import SideBar from "../../Common/SideBar";
import { useSelector } from "react-redux";
import "./styles/ProjectDetailsScreen.css";
import { projectStatus } from "../../../utils";
import PostedProjectDetails from "./Components/PostedProjectDetails";
import ActiveProjectDetails from "./Components/ActiveProjectDetails";
import CompletedProjectDetails from "./Components/CompletedProjectDetails";
import { useFetchProjectDetailsQuery } from "../../../services/baseQuery";
import { OvalLoader } from "../../Common/Loaders";

export default function ProjectDetailsScreen() {
  const { id: projectId, status } = useParams();
  const navigate = useNavigate();
  const sidebar = useSelector(state => state.sidebar);

  console.log(projectId, status, "<<< projectId and status");

  const {
    data: project,
    isLoading,
    isError,
    error,
  } = useFetchProjectDetailsQuery({ projectId, status }, { skip: !projectId });

  console.log(project, "<<< project");

  const handleBack = () => {
    navigate("/allprojects");
  };

  return (
    <div className="MainContainer">
      <SideBar />
      <div
        style={{
          width: sidebar.expand ? "84vw" : "95vw",
          overflowY: "hidden",
          display: "flex",
          flexDirection: "column",
          height: "97.6vh",
        }}
        className="ScreenContainer"
      >
        {/* upper search bar start */}
        <div className="upperSearchBarContainer">
          <div className="upperBarSearchBar">
            <div className="pageHeadingInnerContainer">
              <div className="headerWithBack">
                <div className="backButton" onClick={handleBack}>
                  <img
                    src={require("../../../assets/back.png")}
                    alt="back-button"
                  />
                </div>
                <div className="pageHeading">
                  {status === projectStatus.POSTED
                    ? "Posted Project"
                    : status === projectStatus.ACTIVE
                    ? "Active Project"
                    : "Completed Project"}
                </div>
              </div>
            </div>
          </div>

          <div
            className="upperBarSearchBox upperBarSearchBoxProfile"
            style={{ border: "none" }}
          >
            <img
              src={require("../../../assets/profile.png")}
              alt="profile-pic"
            />
          </div>
          <div className="upperBarSearchBox upperBarSearchBoxNotification">
            <img
              src={require("../../../assets/exit.png")}
              alt="notification-bell"
            />
          </div>
        </div>

        {/* Search bar
        <div
          className="upperSearchBarContainer"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1.5vh",
          }}
        >
          <input placeholder="Search..." className="upperBarSearchBarInput" />
          <div className="searchButton">Search</div>
        </div> */}

        {/* Project details content */}
        {isLoading ? (
          <div className="loaderContainer">
            <OvalLoader />
          </div>
        ) : isError ? (
          <div className="errorState">
            <div className="errorStateText">
              {error?.error || "Error loading project details"}
            </div>
          </div>
        ) : !project ? (
          <div className="emptyState">
            <div className="emptyStateText">Project not found</div>
          </div>
        ) : (
          <>
            {status === projectStatus.POSTED && (
              <PostedProjectDetails project={project} />
            )}
            {status === projectStatus.ACTIVE && (
              <ActiveProjectDetails project={project} />
            )}
            {status === projectStatus.COMPLETE && (
              <CompletedProjectDetails project={project} />
            )}
          </>
        )}
      </div>

      <style jsx>{`
        .loaderContainer {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 400px;
        }

        .errorState,
        .emptyState {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100px;
          color: #ff4d4f;
          font-size: 16px;
        }
      `}</style>
    </div>
  );
}
